import { ChallengesComplexity } from '@services/gateways/combined-assign-gateway/combined-assign-gateway.types';

type UpdateDokFilterByValueParams = {
    updatedDokValue: ChallengesComplexity | null
    currentDokFilter: ChallengesComplexity[]
};

export const updateDokFilterByValue = ({
    updatedDokValue,
    currentDokFilter
}: UpdateDokFilterByValueParams) => {
    return updatedDokValue
        ? currentDokFilter.includes(updatedDokValue)
            ? currentDokFilter.filter(value => value !== updatedDokValue)
            : [...currentDokFilter, updatedDokValue]
        : [];
};
